
const allFieldsets = document.querySelectorAll('#foundation-fieldset')

console.log(allFieldsets)


allFieldsets.forEach((fieldset) => { 
  const inputs = fieldset.querySelectorAll('input[type="radio"]')
  console.log(inputs)
  inputs.forEach((input) => { 
    input.disabled = false
  })

  fieldset.addEventListener('change', () => { 

    //  remove attribute and reapply 

    const previouslyChecked = fieldset.querySelector('input[type="radio"][checked]')
    if (previouslyChecked) {
      previouslyChecked.removeAttribute('checked')
    }


    
    
    console.log('change')
    const selectedInputRadio = fieldset.querySelector('input[type="radio"]:checked')

    // Apply 'checked' attribute to currently selected radio input
    selectedInputRadio.setAttribute('checked', true)

    // update varaint title 
    const selectedTitle  = fieldset.querySelector('.selected')
    selectedTitle.innerText = selectedInputRadio.dataset.title


    let godInput = fieldset.querySelector('#god-input')
    const selectedValue = selectedInputRadio.value

    console.log(godInput.value , 'before')
    godInput.value = selectedValue
    console.log(godInput.value , 'after')
  
    // console.log(selectedValue, 'selectedValue')
  })
})